import Block from '../block'

export default class ShoppingcartProduct extends Block {
	static title = 'shoppingcart-product'

	constructor($el) {
		super($el)

		this.delete = this.$el.findElement('delete')
		this.min = this.$el.findElement('min')
		this.plus = this.$el.findElement('plus')
		this.countInput = this.$el.findElement('count')
		this.currentCount = this.countInput.val()

		this.delete.on('click', () => this.deleteProduct(this.$el.data('id')))

		this.min.on('click', () => this.updateProduct(this.$el.data('id'), 'min'))
		this.plus.on('click', () => this.updateProduct(this.$el.data('id'), 'plus'))
		this.countInput.on('sl-change', () =>
			this.updateProduct(this.$el.data('id')),
		)
	}

	deleteProduct(id) {
		this.setDeleteLoading(true)
		const data = new FormData()

		data.append('ajax', true)
		data.append('id', this.$el.data('id'))
		data.append('delete', true)

		$.ajax({
			method: 'POST',
			processData: false,
			contentType: false,
			cache: false,
			url: '/shoppingcart',
			data: data,
		})
			.done((json) => {
				// check for errors
				if (json.status) {
					$(document).trigger('product:remove', json)
					// remove element from DOM
					this.$el.remove()
					$(document).trigger('shoppingcart:remove-from-cart', id)
				} else {
					$(document).trigger('message:error', { message: json.error })
				}
			})
			.fail(() => {
				$(document).trigger('message:error', {
					message: this.$el.data('requestError'),
				})
			})
			.always(() => this.setDeleteLoading(false))
	}

	updateProduct(id, type = null) {
		this.setNumberLoading(true)
		const data = new FormData()

		data.append('ajax', true)
		data.append('id', this.$el.data('id'))
		data.append('update', true)
		let count = parseInt(this.countInput.val())

		// check if count is changed with icon or not
		if (type == 'min') {
			count = count - 1
		}

		if (type == 'plus') {
			count = count + 1
		}

		data.append('count', count)

		$.ajax({
			method: 'POST',
			processData: false,
			contentType: false,
			cache: false,
			url: '/shoppingcart',
			data: data,
		})
			.done((json) => {
				// check for errors
				if (!json.error) {
					// remove if count is 0 or lower
					if (count <= 0) {
						this.$el.remove()
						$(document).trigger('shoppingcart:remove-from-cart', id)
					} else {
						if (this.currentCount > count) {
							$(document).trigger('shoppingcart:event', {
								type: 'remove_from_cart',
								id: id,
								count: this.currentCount - count,
							})
						} else {
							$(document).trigger('shoppingcart:event', {
								type: 'add_to_cart',
								id: id,
								count: count - this.currentCount,
							})
						}
						this.countInput.val(count)
						this.currentCount = this.countInput.val()
					}
					$(document).trigger('product:update', json)
				} else {
					$(document).trigger('message:error', { message: json.error })
				}
			})
			.fail(() => {
				$(document).trigger('message:error', {
					message: this.$el.data('requestError'),
				})
			})
			.always(() => this.setNumberLoading(false))
	}

	setDeleteLoading(bool) {
		if (bool) {
			this.$el.findElement('loader').removeClass('hidden')
		} else {
			this.$el.findElement('loader').addClass('hidden')
		}
	}

	setNumberLoading(bool) {
		const number = this.$el.findElement('number')

		number.attr('aria-busy', bool)
		this.countInput.prop('noSpinButtons', bool)

		if (bool) {
			number.addModifier('disabled')
		} else {
			number.removeModifier('disabled')
		}
	}
}
